import requestAction from '../../utils/requestAction'

export const fetchComplaintInternalMessages = (complaintId: string) =>
  requestAction('COMPLAINT_INTERNAL_MESSAGE')(`complaints/internal/message/${complaintId}`, 'GET')